import { ReleaseResolution } from '../wizards/common/releaseResolutionTypes';

/**
 * The links a resolution found, keyed by the service they belong to.
 *
 * The first link a service answers with wins: the resolver puts the pasted
 * release first and the searched matches after it, so what the artist gave us
 * is never overwritten by something we guessed. A link we could not file under
 * a service is dropped — the editor draws one row per service, and there is no
 * row for "somewhere".
 */
export function serviceLinksFromResolution(resolution: ReleaseResolution): Record<string, string> {
  const links: Record<string, string> = {};
  const found = resolution.main === undefined ? resolution.others : [resolution.main, ...resolution.others];

  for (const link of found) {
    const { source } = link;
    const url = link.data.url ?? undefined;
    if (source !== undefined && url !== undefined && links[source] === undefined) {
      links[source] = url;
    }
  }

  return links;
}
